export default "__VITE_ASSET__6NsSZsEa__"